import React, { useEffect, useState, useRef, useCallback } from "react";
import { Button, Typography } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Tooltip from "@mui/material/Tooltip";
import "./MObjectStart.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toast.css";
import Alert from "@mui/material/Alert";
import DropZone from "./components/DropZone";
import { CsvMapper } from "./components/CsvMapper";
import { useAuthState } from "@bamboobox/b2logincheck";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import {
	mandatoryMappingFields,
	otherMappingFields,
	crmLeadsMandatoryMappingFields,
	crmLeadsOtherMappingFields,
	crmAccountsMandatoryMappingFields,
	crmAccountsOtherMappingFields,
	crmContactsMandatoryMappingFields,
	crmContactsOtherMappingFields,
	crmOpportunitiesMandatoryMappingFields,
	crmOpportunitiesOtherMappingFields,
	crmAccountsLabelToMongoKey,
} from "./constants";
import DeleteIcon from "@material-ui/icons/Delete";
import {
	allDbMappings,
	crmLeadsAllDbMappings,
	crmAccountsAllDbMappings,
	crmContactsAllDbMappings,
	crmOpportunitiesAllDbMappings,
} from "./constants";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import ChevronLeftIcon from "./chevron-left.svg";
import DeleteButton from "./delete-button.svg";
import ArrowsSortIcon from "./arrows-sort.svg";
import FilterListIcon from "./filter-list.svg";
import DownloadIcon from "./file-download.svg";
import FileUploadIcon from "./file-upload.svg";
import DashboardEmptyIcon from "./Dashboard_empty.svg";
import ChevronDownIcon from "./chevron-down.svg";
import SearchIcon from "./Frame.svg"
import UploadButton from "./upload.svg"
import PageNextIcon from "./next-page.svg";
import PagePrevIcon from "./previous-page.svg";
import RowsDropdownIcon from "./rows-dropdown.svg";
import Accounts from "./accounts.svg";
import AccountsBox from "./accounts_box.svg";
import Activities from "./activities.svg";
import Contacts from "./contacts.svg";
import ImportType from "./import-type.svg";
import Leads from "./leads.svg";
import Opportunities from "./opportunities.svg";
import Draft from "./edit.svg";
import Download from "./download.svg";
import CircleX from "./circle-x.svg";
import SaveIcon from "./device-floppy.svg";
import Upload from "./upload_purple.svg";
import Info from "./info-icon.svg";
import Next from "./arrow-right.svg";
import Help from "./help-circle.svg";
import InfoCircle from "./info-circle.svg";
import ChevronRightIcon from "./chevron-right.svg";
import AlertCircle from "./alert-circle.svg";
import Illustration from "./container_Illustration.svg"
// import InfoCircle from "./info-circle.svg";
import CheckIcon from "./check.svg";

const config = require("./config.json")
const { v5: uuidv5 } = require('uuid');

const useStyles = makeStyles((theme) => ({
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120,
	},
}));

function ManualObjectStart(props) {
	const classes = useStyles();

	toast.configure({
		autoClose: 6000,
		draggable: true,
		hideProgressBar: false,
		position: toast.POSITION.BOTTOM_LEFT,
		icon: false,
	});

	const [showDefault, setShowDefault] = useState(0);
	const [confirmOpen, setConfirmOpen] = useState(false);
	const [pendingUploadData, setPendingUploadData] = useState(null);
	const abortControllerRef = useRef(null);
	const [step, setStep] = useState("list");
	const [selectedFileData, setSelectedFileData] = useState();
	const [isPicked, setIsPicked] = useState(false);
	const [selectFileName, setSelectFileName] = useState();
	const [csvheaders, setCSVHeaders] = useState([]);
	const tenantId = useAuthState().user.tenantId;
	const userId = useAuthState().user.userUuid;
	const [columnsmatched, setColumnsMatched] = useState(allDbMappings.length);
	const [columnsleft, setColumnsLeft] = useState(0);
	const [headerMappings, setHeaderMappings] = useState({});
	const [preSelectedMappings, setPreSelectedMappings] = useState([...allDbMappings]);
	const [backDropOpen, setBackDropOpen] = useState(false);
	const [crmType, setCrmType] = useState("leads");
	const [isActivities, setIsActivities] = useState(true);
	const [batchId, setBatchId] = useState(null);
	const [importStats, setImportStats] = useState(null); // { totalRows, rowsImported, failedRows }
	const [reviewStatus, setReviewStatus] = useState("loading"); // "loading" | "completed"
	const [previewRows, setPreviewRows] = useState([]);
	const pollIntervalRef = useRef(null);
	const [mandatoryMappings, setMandatoryMappings] = useState([...mandatoryMappingFields]);
	const [otherMappings, setOtherMappings] = useState([...otherMappingFields]);
	const [allMappings, setAllMappings] = useState([]);
	const [downloadHandler, setDownloadHandler] = useState(null);
	const [importName, setImportName] = useState("");
	const [importNameError, setImportNameError] = useState("");
	const [viewportWidth, setViewportWidth] = useState(
		typeof window !== "undefined" ? window.innerWidth : 1440
	);
	const [carouselIndex, setCarouselIndex] = useState(0);
	const [isTransitioning, setIsTransitioning] = useState(true);

	const carouselItems = [
		{ title: "Uploading and preparing your data…", description: "We’re reading your file and getting things ready for import." },
		{ title: "Validating file structure…", description: "Checking columns, formats, and required fields" },
		{ title: "Mapping fields and Cleaning Duplicates…", description: "Aligning your data with system fields and ensuring its accuracy" }
	];

	useEffect(() => {
		if (step === "review" && reviewStatus === "loading") {
			const timer = setInterval(() => {
				setCarouselIndex((prev) => prev + 1);
			}, 3000);
			return () => clearInterval(timer);
		}
	}, [step, reviewStatus]);

	useEffect(() => {
		if (carouselIndex === carouselItems.length) {
			const resetTimer = setTimeout(() => {
				setIsTransitioning(false);
				setCarouselIndex(0);
				const reEnableTimer = setTimeout(() => {
					setIsTransitioning(true);
				}, 50);
				return () => clearTimeout(reEnableTimer);
			}, 600);
			return () => clearTimeout(resetTimer);
		}
	}, [carouselIndex, carouselItems.length]);

	useEffect(() => {
		const handleResize = () => setViewportWidth(window.innerWidth);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const getFallbackMappings = useCallback((_crmType, _isActivities) => {
		if (_isActivities) {
			return allDbMappings.map((field) => ({
				label: field,
				value: field,
			}));
		}

		const { allMappingFields } = getMappingFields(_crmType);
		return allMappingFields.map((field) => ({
			label: field,
			value: field,
		}));
	}, []);

	const isAccountScopedField = useCallback((field = {}) => {
		const normalizedTableName = String(field?.tableName || "").toLowerCase();
		const normalizedSource = String(field?.source || "").toLowerCase();
		const normalizedGroupLabel = String(field?.groupLabel || "").toLowerCase();

		return (
			normalizedTableName === "accounts" ||
			normalizedTableName === "account" ||
			normalizedSource === "account" ||
			normalizedSource === "accounts" ||
			normalizedGroupLabel === "account" ||
			normalizedGroupLabel === "accounts"
		);
	}, []);

	const fetchTenantFields = useCallback(async (_crmType, _isActivities) => {
		try {
			if (_isActivities || _crmType !== "accounts") {
				setAllMappings(getFallbackMappings(_crmType, _isActivities));
				return;
			}

			const url = `${window._env_.TENANT_CONFIG}/tenant/field/mapper/get/${tenantId}/unified-profile-ui`;
			const response = await fetch(url, {
				method: "GET",
				credentials: "include",
			});
			const payload = await response.json();
			const tenantFieldMap =
				payload && typeof payload === "object" && payload.data && typeof payload.data === "object"
					? payload.data
					: payload;
			const tenantMappings = Object.entries(tenantFieldMap || {})
				.filter(([_, field]) => field?.label)
				.sort((a, b) => (a[1]?.order || 0) - (b[1]?.order || 0))
				.filter((field) => isAccountScopedField(field[1]))
				.map(([key, field]) => ({
					label: field?.label || key,
					value: key,
				}))
				.filter(
					(field, index, arr) =>
						arr.findIndex(
							(otherField) =>
								otherField.value === field.value || otherField.label === field.label
						) === index
				);

			if (!tenantMappings.length) {
				setAllMappings(getFallbackMappings(_crmType, _isActivities));
				return;
			}

			setAllMappings(tenantMappings);
		} catch (error) {
			console.error("Failed to fetch tenant fields", error);
			setAllMappings(getFallbackMappings(_crmType, _isActivities));
		}
	}, [getFallbackMappings, isAccountScopedField, tenantId]);

	const resolveMappingLabel = useCallback(
		(mappingValue) =>
			allMappings.find((field) => field?.value === mappingValue)?.label || mappingValue,
		[allMappings]
	);

	useEffect(() => {
		if (step !== "mapping") return;

		setAllMappings(getFallbackMappings(crmType, isActivities));
		fetchTenantFields(crmType, isActivities);
	}, [step, crmType, isActivities, getFallbackMappings, fetchTenantFields]);
	// const ref = React.createRef();

	const handleNewClick = (event) => {
		setBackDropOpen(false); // if file upload failed -> loader must be removed
		setStep("selectType");
	};

	// const handleCloseDialog = (event) => {
	// 	setOpen(false);
	// 	reSelect();
	// };

	const selectChangeHandler = (event, ele1) => {
		console.log("event cominng from changeHandler", event?.target?.value);
		console.log("event cominng from changeHandler1", ele1);

		let newHeaderColumnsValue = {};
		newHeaderColumnsValue[ele1] = event.target.value;

		setHeaderMappings((prev) => {
			return { ...prev, ...newHeaderColumnsValue };
		});

		// console.log("headerMappings", headerMappings)

		// if (mandatoryMappingFields.includes(event?.target?.value) && columnsleft > 0) {
		//     let decrement = columnsleft - 1
		//     setColumnsLeft(decrement)
		// }

		// if (columnsmatched < csvheaders.length) {
		//     let increment = columnsmatched + 1
		//     setColumnsMatched(increment)
		// }
	};

	//all mapping fields for each crm type from constants.js
	const getMappingFields = (_crmType) => {
		const mappings = {
			leads: [crmLeadsMandatoryMappingFields, crmLeadsOtherMappingFields, crmLeadsAllDbMappings],
			accounts: [crmAccountsMandatoryMappingFields, crmAccountsOtherMappingFields, crmAccountsAllDbMappings],
			contacts: [crmContactsMandatoryMappingFields, crmContactsOtherMappingFields, crmContactsAllDbMappings],
			opportunities: [crmOpportunitiesMandatoryMappingFields, crmOpportunitiesOtherMappingFields, crmOpportunitiesAllDbMappings],
		};

		return {
			mandatoryMappingFields: mappings[_crmType][0],
			otherMappingFields: mappings[_crmType][1],
			allMappingFields: mappings[_crmType][2],
		};
	};

	const mapForActivities = (_headerMappings) => {
		// console.log('mapforActivities');
		let headerMappingAllValuesArr = [];
		let lengthofheaderMappings = 0;

		// console.log('going in for mapForActivities headerMappings');
		for (let key in _headerMappings) {
			if (_headerMappings[key]) {
				lengthofheaderMappings += 1;
				headerMappingAllValuesArr.push(resolveMappingLabel(_headerMappings[key]));
				// console.log(`headerMapppings[${key}]: ${_headerMappings[key]}`);
			}
		}

		let mandatoryMatched = 0;
		let uniqueheaderMappingValuesArr = new Set(headerMappingAllValuesArr);
		for (let mapping_ele of mandatoryMappingFields) {
			if (uniqueheaderMappingValuesArr.has(mapping_ele)) {
				mandatoryMatched += 1;
			}
		}

		setColumnsLeft(mandatoryMappingFields.length - mandatoryMatched);
		setColumnsMatched(lengthofheaderMappings);

		setMandatoryMappings([...mandatoryMappingFields]);
		setOtherMappings([...otherMappingFields]);
		// console.log('mandatoryMatched', mandatoryMatched);
		// console.log('mandatoryMappingFields', mandatoryMappingFields);
		// console.log('columnsLeft ', columnsleft);
		// console.log('columnsMactched ', columnsmatched);
	};

	const mapForCRM = (_headerMappings, _crmType) => {
		// console.log('mapforCRM');
		let headerMappingAllValuesArr = [];
		let lengthofheaderMappings = 0;

		// console.log('going in for mapforCRM headerMappings');
		for (let key in _headerMappings) {
			if (_headerMappings[key]) {
				lengthofheaderMappings += 1;
				headerMappingAllValuesArr.push(resolveMappingLabel(_headerMappings[key]));
				// console.log(`headerMapppings[${key}]: ${_headerMappings[key]}`);
			}
		}

		let mandatoryMatched = 0;
		let uniqueheaderMappingValuesArr = new Set(headerMappingAllValuesArr);
		let uniqueheaderMappingRawValuesArr = new Set(
			Object.values(_headerMappings).filter(Boolean)
		);
		const { mandatoryMappingFields, otherMappingFields, allMappingFields } = getMappingFields(_crmType);
		// console.log('mandatoryMappingFields', mandatoryMappingFields);

		for (let mapping_ele of mandatoryMappingFields) {
			if (uniqueheaderMappingValuesArr.has(mapping_ele)) {
				mandatoryMatched += 1;
			}
		}

		if (_crmType === "accounts") {
			if (
				uniqueheaderMappingRawValuesArr.has("accountName") &&
				!uniqueheaderMappingValuesArr.has("Account Name")
			) {
				mandatoryMatched += 1;
			}

			if (
				uniqueheaderMappingRawValuesArr.has("accountWebsite") &&
				!uniqueheaderMappingValuesArr.has("Website")
			) {
				mandatoryMatched += 1;
			}
		}

		setColumnsLeft(mandatoryMappingFields.length - mandatoryMatched);
		setColumnsMatched(lengthofheaderMappings);

		setMandatoryMappings([...mandatoryMappingFields]);
		setOtherMappings([...otherMappingFields]);
	};

	useEffect(() => {
		if (step !== "mapping") return;
		//call mapping method based on whether activites if chosen or not
		isActivities ? mapForActivities(headerMappings) : mapForCRM(headerMappings, crmType);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [allMappings, crmType, headerMappings, isActivities, step, resolveMappingLabel]);

	const reSelect = () => {
		//reset all values/states to default
		setIsPicked(false);
		setCSVHeaders([]);
		setSelectFileName(undefined);
		setSelectedFileData(undefined);
		setHeaderMappings({});
		setColumnsLeft(0);
		setIsActivities(true);
		setCrmType("leads");
		setImportName("");
		setImportNameError("");
	};

	const toastMessageCRM = (isSuccess, _message) => {
		!isSuccess
			? toast.error(<Alert severity='error'>{_message}</Alert>, {
				closeOnClick: true,
				autoClose: true,
				closeButton: true,
				newestOnTop: true,
			})
			: toast.success(<Alert severity='success'>{_message}</Alert>, {
				closeOnClick: true,
				autoClose: true,
				closeButton: true,
				newestOnTop: true,
			});
	};

	const uploadCRM = async (data) => {
		//check for mandatory fields unmatched. if unmatched, show error toast message
		if (columnsleft > 0) {
			toast.error(<Alert severity='error'>{columnsleft} mandatory columns left</Alert>, {
				closeOnClick: true,
				autoClose: true,
				closeButton: true,
				newestOnTop: true,
			});
			setBackDropOpen(false);
			return;
		}

		try {
			// accounts route has no :tenantId in the URL — tenantId is sent in the body instead
			const url = crmType === "accounts"
				? `${window._env_.OFFLINE_UPLOAD}/offline-data-import/post-crm/v2/accounts`
				: `${window._env_.OFFLINE_UPLOAD}/offline-data-import/post-crm/v2/${crmType}`;
			const response = await fetch(url, {
				credentials: "include",
				method: "POST",
				body: data,
				signal: abortControllerRef.current?.signal,
			});
			const result = await response.json();

			if (result.success) {
				const returnedBatchId = result.data?.batchId;
				setBatchId(returnedBatchId);
				setReviewStatus("loading");
				setBackDropOpen(false);
				setStep("review");
				pollImportStatus(returnedBatchId);
			} else {
				setBackDropOpen(false);
				toastMessageCRM(false, result.message);
			}
		} catch (err) {
			toastMessageCRM(false, "Unable to reach the server. Please check your connection.");
		}
	};

	const saveAccountsMappings = async (generatedBatchId) => {
		const response = await fetch(
			`${window._env_.OFFLINE_UPLOAD}/offline-data-import/mappings/${tenantId}/${userId}/account/${generatedBatchId}`,
			{
				method: "POST",
				credentials: "include",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					mappings: Object.fromEntries(
						Object.entries(headerMappings).map(([csvCol, label]) => [
							csvCol,
							crmAccountsLabelToMongoKey[label] || label,
						])
					),
				}),
			}
		);
		const result = await response.json();

		if (!response.ok || !result.success) {
			throw new Error(result?.message || "Failed to save mappings");
		}

		return result;
	};

	const pollImportStatus = (returnedBatchId) => {
		if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
		pollIntervalRef.current = setInterval(async () => {
			try {
				const res = await fetch(`${window._env_.OFFLINE_UPLOAD}/import-history/getHistory/${tenantId}`, {});
				const data = await res.json();
				const history = data?.data || [];
				const entry = history.find(h => h.batchId === returnedBatchId);
				if (entry && (entry.status === "VALIDATION_COMPLETED" || entry.status === "SYNC_COMPLETED" || entry.status === "VALIDATION_FAILED" || entry.status === "UPLOAD_FAILED")) {
					clearInterval(pollIntervalRef.current);
					setImportStats({ totalRows: entry.totalRows, rowsImported: entry.rowsImported, failedRows: entry.failedRows });
					setReviewStatus("completed");
				}
			} catch (e) {
				console.error("Poll error:", e);
			}
		}, 4000);
	};

	const uploadButtonClicked = async (event) => {

		var data = new FormData();
		data.append("file", selectedFileData?.selectedFile);
		data.append("fileName", selectFileName);
		data.append("headerMappings", JSON.stringify(headerMappings));
		data.append("order", JSON.stringify(csvheaders));

		// accounts controller reads these from req.body (no :tenantId in its URL)

		// const generatedBatchId = `batch-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
		const generatedBatchId = uuidv5(tenantId + userId + crmType + importName, config.namespace);

		if (crmType === "accounts") {
			data.append("tenantId", tenantId);
			data.append("userId", userId);
			data.append("batchId", generatedBatchId);

			// importTitle is a required field, do not let user not enter a title before proceeding to upload
			data.append("importTitle", importName || selectFileName || "Manual Upload");
		}

		setPendingUploadData(data);
		setConfirmOpen(true);
	};

	const handleConfirm = async () => {
		setConfirmOpen(false);
		const data = pendingUploadData;
		abortControllerRef.current = new AbortController();

		//upload crm data if not activity
		if (!isActivities) {
			if (crmType === "accounts") {
				try {
					await saveAccountsMappings(data.get("batchId"));
				} catch (error) {
					setBackDropOpen(false);
					toastMessageCRM(false, error.message || "Failed to save mappings");
					return;
				}
			}
			setReviewStatus("loading");
			setPreviewRows(selectedFileData?.parsedData?.slice(0, 10) || []);
			setStep("review");
			uploadCRM(data);
			return;
		}

		if (columnsleft > 0) {
			toast.error(<Alert severity='error'>{columnsleft} mandatory columns left</Alert>, {
				closeOnClick: true,
				autoClose: true,
				closeButton: true,
				newestOnTop: true,
			});

			return;
		}


		try {
			const res = await fetch(`${window._env_.OFFLINE_UPLOAD}/offline-data-import/upload-csv-data/${tenantId}`, {
				credentials: 'include',
				method: 'POST',
				body: data,
				signal: abortControllerRef.current?.signal,
			});

			const result = await res.json();


			setStep("list");
			reSelect();

			if (result.success) {
				setBackDropOpen(false);
				toast.success(<Alert severity='success'>{result.message}</Alert>, {
					closeOnClick: true,
					autoClose: true,
					closeButton: true,
					newestOnTop: true,
				});
			} else {
				setBackDropOpen(false);
				toast.error(<Alert severity='error'>{result.message}</Alert>, {
					closeOnClick: true,
					autoClose: true,
					closeButton: true,
					newestOnTop: true,
				});
			}
		} catch (err) {
			setBackDropOpen(false);
			toast.error(<Alert severity='error'>Unable to reach the server. Please check your connection.</Alert>, {
				closeOnClick: true,
				autoClose: true,
				closeButton: true,
				newestOnTop: true,
			});
		}
	};
	const cardStyle = {
		height: 100,
		display: "flex",
		alignItems: "center",
		border: "1px solid #E5E7EB",
		borderRadius: 8,
		padding: 24,
		cursor: "pointer",
		width: "100%",
		boxSizing: "border-box",
	};

	const cardInnerStyle = {
		display: "flex",
		alignItems: "center",
		gap: 16,
	};

	const iconBoxStyle = {
		width: 48,
		height: 48,
		borderRadius: 8,
		background: "#F3F4F6",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	};

	const subTextStyle = {
		fontSize: 12,
		color: "#6B7280",
		marginTop: 4,
	};
	const desktopShellAspectRatio = "1330 / 747";
	const isTabletLayout = viewportWidth <= 1024;
	const isMobileLayout = viewportWidth <= 768;
	const stepShellStyle = {
		display: "grid",
		gridTemplateColumns: isTabletLayout ? "minmax(0, 1fr)" : "minmax(0, 906fr) minmax(320px, 400fr)",
		gap: 24,
		alignItems: isTabletLayout ? "start" : "stretch",
		flex: 1,
		height: "100%",
		minHeight: 0,
		width: "100%",
		aspectRatio: isTabletLayout ? undefined : desktopShellAspectRatio,
		minWidth: 0,
		maxWidth: "100%",
		margin: 0,
	};
	const leftStepCardStyle = {
		background: "#FFFFFF",
		//border: "1px solid #E5E7EB",
		borderRadius: 8,
		boxSizing: "border-box",
		width: "100%",
		minHeight: isTabletLayout ? "auto" : 0,
		height: isTabletLayout ? "auto" : "100%",
		display: "flex",
		flexDirection: "column",
		overflow: "hidden",
	};
	const leftCardTopSectionStyle = {
		padding: "24px 24px 0",
		boxSizing: "border-box",
	};
	const leftCardStepperSectionStyle = {
		padding: "14px 20px",
		borderBottom: "1px solid #E5E7EB",
		boxSizing: "border-box",
	};
	const leftCardBodySectionStyle = {
		flex: isTabletLayout ? "0 1 auto" : 1,
		padding: "0 24px 24px",
		boxSizing: "border-box",
		display: "flex",
		flexDirection: "column",
		height: "100%",
		// minHeight: 0,
	};
	const leftCardScrollableBodyStyle = {
		...leftCardBodySectionStyle,
		overflowY: isTabletLayout ? "visible" : "auto",
		overflowX: "hidden",
	};
	const leftCardFooterStyle = {
		padding: "24px",
		background: "#FFFFFF",
		borderTop: "1px solid #EEEEEE",
		boxShadow: "0 -4px 10px 0 rgba(0, 0, 0, 0.03)",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		gap: 12,
		boxSizing: "border-box",
		flexShrink: 0,
	};
	const rightStepCardStyle = {
		background: "#FFFFFF",
		//border: "1px solid #E5E7EB",
		borderRadius: 8,
		boxSizing: "border-box",
		width: "100%",
		minHeight: isTabletLayout ? "auto" : 0,
		height: isTabletLayout ? "auto" : "100%",
		display: "flex",
		flexDirection: "column",
		overflow: "hidden",
	};
	const guidelinesSections = [
		{
			title: "File Size",
			body: "Ensure the upload file is complete and consistent before starting the import.",
		},
		{
			title: "File Format",
			body: "Use CSV format only and keep the first row for column headers.",
		},
		{
			title: "Duplication Rules",
			body: "Avoid duplicate rows and confirm key identifiers are mapped correctly.",
		},
		{
			title: "CSV column addition info",
			body: "Extra CSV columns remain unmapped unless they are linked to a BambooBox field.",
		},
		{
			title: "",
			body: "Mandatory fields must not be empty and mappings should be reviewed before import.",
		},
	];
	const renderGuidelinesCard = () => (
		<div style={rightStepCardStyle}>
			<div
				style={{
					padding: "14px 20px",
					borderBottom: "1px solid #E5E7EB",
					display: "flex",
					alignItems: "center",
					gap: 8,
					fontFamily: "Inter",
					fontSize: 14,
					fontWeight: 600,
					lineHeight: "100%",
					letterSpacing: "0%",
					color: "#424242",
					style: "semibold",
				}}
			>
				<img src={Help} alt="help" style={{ width: 20, height: 20, flexShrink: 0 }} />
				<span>Data Import Guidelines</span>
			</div>
			<div style={{ padding: "16px 24px", flex: 1, overflowY: isTabletLayout ? "visible" : "auto" }}>
				{guidelinesSections.map((section, index) => (
					<div
						key={`${section.title || "footer"}-${index}`}
						style={{
							padding: index === 0 ? "0 0 16px" : "16px 0",
							borderBottom: index === guidelinesSections.length - 1 ? "none" : "1px solid #E5E7EB",
						}}
					>
						{section.title ? (
							<div
								style={{
									fontFamily: "Inter, sans-serif",
									fontSize: 12,
									fontWeight: 600,
									lineHeight: "12px",
									color: "#424242",
									marginBottom: 8,
								}}
							>
								{section.title}
							</div>
						) : null}
						<div
							style={{
								fontFamily: "Inter, sans-serif",
								fontSize: 12,
								fontWeight: 500,
								lineHeight: "12px",
								color: "#616161",
							}}
						>
							{section.body}
						</div>
					</div>
				))}
			</div>
		</div>
	);
	const getActiveStep = () => {
		if (step === "upload") return 1;
		if (step === "mapping") return 2;
		if (step === "review") return 3;
		return 1;
	};

	const activeStep = getActiveStep();
	const renderStepperSection = () => (
		<div style={leftCardStepperSectionStyle}>
			<div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", rowGap: 10 }}>
				<div style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }} onClick={() => setStep("upload")}>
					<div
						style={{
							width: 20,
							height: 20,
							borderRadius: 6,
							background: activeStep === 1 ? "#5441D8" : "#EEEEEE",
							color: activeStep === 1 ? "#FFFFFF" : "#6B7280",
							fontSize: 12,
							fontWeight: 500,
							fontFamily: "Inter",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						1
					</div>

					<span
						style={{
							fontFamily: "Inter",
							fontWeight: 500,
							fontSize: "12px",
							lineHeight: "100%",
							color: activeStep === 1 ? "#5441D8" : "#9CA3AF",
						}}
					>
						Upload File
					</span>
				</div>

				<img
					src={ChevronRightIcon}
					alt="chevron"
					style={{ width: 14, height: 14, margin: "0 16px" }}
				/>

				<div style={{ display: "flex", alignItems: "center", gap: 6, cursor: isPicked ? "pointer" : "default", opacity: isPicked ? 1 : 0.5 }} onClick={() => isPicked && setStep("mapping")}>
					<div
						style={{
							width: 20,
							height: 20,
							borderRadius: 6,
							background: activeStep === 2 ? "#5441D8" : "#EEEEEE",
							color: activeStep === 2 ? "#FFFFFF" : "#6B7280",
							fontSize: 12,
							fontWeight: 500,
							fontFamily: "Inter",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						2
					</div>

					<span
						style={{
							fontFamily: "Inter",
							fontWeight: 500,
							fontSize: "12px",
							lineHeight: "100%",
							color: activeStep === 2 ? "#5441D8" : "#9CA3AF",
						}}
					>
						Field Mapping
					</span>
				</div>

				<img
					src={ChevronRightIcon}
					alt="chevron"
					style={{ width: 14, height: 14, margin: "0 16px" }}
				/>

				<div style={{ display: "flex", alignItems: "center", gap: 6 }}>
					<div
						style={{
							width: 20,
							height: 20,
							borderRadius: 6,
							background: activeStep === 3 ? "#5441D8" : "#EEEEEE",
							color: activeStep === 3 ? "#FFFFFF" : "#6B7280",
							fontSize: 12,
							fontWeight: 500,
							fontFamily: "Inter",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						3
					</div>

					<span
						style={{
							fontFamily: "Inter",
							fontWeight: 500,
							fontSize: "12px",
							lineHeight: "100%",
							color: activeStep === 3 ? "#5441D8" : "#9CA3AF",
							textTransform: "capitalize",
						}}
					>
						Review Imported Data
					</span>
				</div>
			</div>
		</div>
	);
	return (
		<React.Fragment>
			{/* ===== PERSISTENT OBJECT HEADER ===== */}
			{(step === "upload" || step === "mapping" || step === "review") && (
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						padding: "16px 24px",
						//borderBottom: "1px solid #E5E7EB",
						//background: "#FFFFFF",
					}}
				>
					{/* LEFT SECTION */}
					<div style={{ display: "flex", alignItems: "center", gap: 16 }}>

						{/* Back Icon */}
						<img
							src={ChevronLeftIcon}
							alt="back"
							style={{ width: 20, height: 20, cursor: "pointer" }}
							onClick={() => { reSelect(); setStep("list"); }}
						/>

						{/* Title */}
						<h2
							style={{
								fontFamily: "Inter",
								fontWeight: 500,
								fontSize: "16px",
								lineHeight: "100%",
								color: "#424242",
								margin: 0,
							}}
						>
							{importName || "New Import"}
						</h2>

						{/* Accounts Badge */}
						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: "5px",
								height: "24px",
								padding: "4px 8px",
								borderRadius: "4px",
								background: "#E9AA001A"
							}}
						>
							<img
								src={Accounts}
								alt="accounts"
								style={{
									width: 16,
									height: 16,
								}}
							/>

							<span
								style={{
									fontFamily: "Inter",
									fontWeight: 500,
									fontSize: "12px",
									lineHeight: "100%",
									color: "#B28301",
								}}
							>
								Accounts
							</span>
						</div>

						{/* Draft Badge */}
						{/* <div
							style={{
								display: "flex",
								alignItems: "center",
								gap: "4px",
								height: "24px",
								padding: "4px 8px",
								borderRadius: "4px",
								background: "#D19900",
							}}
						>
							<img
								src={Draft}
								alt="draft"
								style={{ width: 16, height: 16 }}
							/>

							<span
								style={{
									fontFamily: "Inter",
									fontWeight: 500,
									fontSize: "12px",
									lineHeight: "100%",
									color: "#FFFFFF",
								}}
							>
								Draft
							</span>
						</div> */}
					</div>

					{/* RIGHT SECTION */}
					{/* <button
						style={{
							display: "flex",
							alignItems: "center",
							gap: 6,
							height: 31,
							padding: "8px 12px",
							borderRadius: 5,
							border: "1px solid #EEEEEE",
							background: "#FFFFFF",
							color: "#9E9E9E",
							fontSize: 12,
							fontWeight: 500,
							fontFamily: "Inter, sans-serif",
							cursor: "pointer",
							boxSizing: "border-box",
							justifyContent: "center",
							whiteSpace: "nowrap"
						}}
					>
						<img src={SaveIcon} alt="save" style={{ width: 14, height: 14, filter: "opacity(0.6)" }} />
						Save as Draft
					</button> */}
				</div>
			)}
			{/* ===== CONFIRM IMPORT DIALOG ===== */}
			<Dialog
				open={confirmOpen}
				onClose={() => setConfirmOpen(false)}
				PaperProps={{
					style: {
						width: 487,
						maxWidth: 487,
						borderRadius: 8,
						padding: 0,
						overflow: "hidden",
					},
				}}
			>
				<div style={{ padding: "24px 32px" }}>
					{/* Header */}
					<Typography
						style={{
							fontWeight: 600,
							fontSize: 18,
							lineHeight: "27px",
							color: "#4B4B4B",
							fontFamily: "Inter, sans-serif",
						}}
					>
						Are you sure you want to Import Data into BambooBox platform?
					</Typography>

					{/* Subtext */}
					<Typography
						style={{
							fontSize: 14,
							color: "#6B7280",
							marginTop: 8,
							fontFamily: "Inter, sans-serif",
						}}
					>
						This will import all the relevant data into the system
					</Typography>

					{/* Note Box */}
					<div
						style={{
							marginTop: 20,
							display: "flex",
							alignItems: "center",
							gap: 8,
							borderRadius: 6,
							padding: "8px 12px",
							background: "#F6F5FF",
							border: "1px solid #E4E0FF",
						}}
					>
						<img
							src={InfoCircle}
							alt="info"
							style={{ width: 14, height: 14, flexShrink: 0 }}
						/>
						<Typography
							style={{
								fontSize: 13,
								color: "#5441D8",
								fontFamily: "Inter, sans-serif",
							}}
						>
							Note: This may take upto 4 hrs to reflect changes
						</Typography>
					</div>

					{/* Action Buttons */}
					<div
						style={{
							marginTop: 32,
							display: "flex",
							justifyContent: "flex-end",
							gap: 12,
						}}
					>
						<Button
							onClick={() => setConfirmOpen(false)}
							style={{
								textTransform: "none",
								color: "#374151",
								border: "1px solid #D1D5DB",
								borderRadius: "6px",
								padding: "10px 12px",
								height: "37px",
								minWidth: "auto",
								fontFamily: "Inter, sans-serif",
								fontWeight: 500,
							}}
						>
							Cancel
						</Button>
						<Button
							onClick={handleConfirm}
							variant="contained"
							style={{
								textTransform: "none",
								backgroundColor: "#5441D8",
								color: "#fff",
								borderRadius: 6,
								padding: "10px 16px",
								minWidth: 75,
								height: 37,
								fontFamily: "Inter, sans-serif",
								fontWeight: 500,
								boxShadow: "none",
							}}
						>
							Confirm
						</Button>
					</div>
				</div>
			</Dialog>

			{/* ===== SELECT IMPORT TYPE DIALOG ===== */}
			<Dialog
				open={step === "selectType"}
				onClose={() => setStep("list")}
				PaperProps={{
					className: "selectTypeDialog",
					style: {
						width: 687,
						maxWidth: 687,
						borderRadius: 8,
					},
				}}
			>
				<div style={{ padding: 32, width: "100%", boxSizing: "border-box" }}>
					<div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
						<img
							src={ImportType}
							alt="import"
							style={{ width: 32, height: 32 }}
						/>

						<div>
							<Typography style={{ fontWeight: 600, fontSize: 16, lineHeight: "100%", color: "#424242", style: "semi-bold" }}>
								Select Import Type
							</Typography>

							<Typography style={{ fontWeight: 500, fontSize: 12, lineHeight: "100%", color: "#757575", marginTop: 6, style: "medium" }}>
								Select the type of import that you want to make.
							</Typography>
						</div>
					</div>
					<div style={{
						marginTop: 24,
						display: "grid",
						gridTemplateColumns: "1fr 1fr",
						gap: 24
					}}>
						{/* Activities */}
						<div style={cardStyle}>
							<div style={cardInnerStyle}>
								<div style={iconBoxStyle}>
									<img src={Activities} alt="Activities" style={{ width: 48, height: 48, display: "block", opacity: 1, borderRadius: "6px" }} />
								</div>
								<div>
									<Typography style={{ fontWeight: 600 }}>
										Activities
									</Typography>
									<Typography style={subTextStyle}>
										Import activities, logs & engagement data
									</Typography>
								</div>
							</div>
						</div>

						{/* Accounts */}
						<div
							style={cardStyle}
							onClick={() => {
								setIsActivities(false);
								setCrmType("accounts");
								setStep("nameImport");
							}}
						>
							<div style={cardInnerStyle}>
								<div style={iconBoxStyle}>
									<img src={AccountsBox} alt="Accounts" style={{ width: 48, height: 48, display: "block", opacity: 1, borderRadius: "6px", background: "#E9AA001A" }} />
								</div>
								<div>
									<Typography style={{ fontWeight: 600 }}>
										Accounts
									</Typography>
									<Typography style={subTextStyle}>
										Import activities, logs & engagement data
									</Typography>
								</div>
							</div>
						</div>

						{/* Contacts */}
						<div style={cardStyle}>
							<div style={cardInnerStyle}>
								<div style={iconBoxStyle}>
									<img src={Contacts} alt="Contacts" style={{ width: 48, height: 48, display: "block", opacity: 1, borderRadius: "6px" }} />
								</div>
								<div>
									<Typography style={{ fontWeight: 600 }}>
										Contacts
									</Typography>
									<Typography style={subTextStyle}>
										Import activities, logs & engagement data
									</Typography>
								</div>
							</div>
						</div>

						{/* Opportunities */}
						<div style={cardStyle}>
							<div style={cardInnerStyle}>
								<div style={iconBoxStyle}>
									<img src={Opportunities} alt="Opportunities" style={{ width: 48, height: 48, display: "block", opacity: 1, borderRadius: "6px" }} />
								</div>
								<div>
									<Typography style={{ fontWeight: 600 }}>
										Opportunities
									</Typography>
									<Typography style={subTextStyle}>
										Import activities, logs & engagement data
									</Typography>
								</div>
							</div>
						</div>

						{/* Leads */}
						<div style={cardStyle}>
							<div style={cardInnerStyle}>
								<div style={iconBoxStyle}>
									<img src={Leads} alt="Leads" style={{ width: 48, height: 48, display: "block", opacity: 1, borderRadius: "6px" }} />
								</div>
								<div>
									<Typography style={{ fontWeight: 600 }}>
										Leads
									</Typography>
									<Typography style={subTextStyle}>
										Import activities, logs & engagement data
									</Typography>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Dialog>
			{/* ===== NAME IMPORT DIALOG ===== */}
			<Dialog
				open={step === "nameImport"}
				onClose={() => {
					setStep("selectType");
					setImportNameError("");
					setImportName("");
				}}
				PaperProps={{
					style: {
						width: 375,
						borderRadius: 8,
						padding: 0,
						overflow: "hidden",
					},
				}}
			>
				{/* Main Content */}
				<div style={{ padding: "24px 24px 16px" }}>

					{/* Top Row */}
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: 16,
							marginBottom: 20,
						}}
					>
						{/* Back Arrow */}
						<img
							src={ChevronLeftIcon}
							alt="Back"
							onClick={() => {
								setStep("selectType");
								setImportNameError("");
								setImportName("");
							}}
							style={{
								width: 16,
								height: 16,
								cursor: "pointer",
							}}
						/>

						{/* Type Tag */}
						{crmType === "accounts" && (
							<div
								style={{
									display: "flex",
									alignItems: "center",
									gap: "5px",
									height: "24px",
									padding: "4px 8px",
									borderRadius: "4px",
									background: "rgba(233,170,0,0.1)",
								}}
							>
								<img
									src={Accounts}
									alt="Accounts"
									style={{
										width: 14,
										height: 14,
									}}
								/>
								<span
									style={{
										fontFamily: "Inter",
										fontWeight: 500,
										fontSize: "12px",
										lineHeight: "100%",
										letterSpacing: "0%",
										color: "#B28301",
									}}
								>
									Accounts
								</span>
							</div>
						)}
					</div>

					{/* Heading */}
					<Typography
						variant="h6"
						sx={{
							fontFamily: "Inter, sans-serif",
							fontSize: 16,
							fontWeight: 600,
							lineHeight: "19px",
							letterSpacing: 0,
							color: "#424242",
							mb: "4px",
						}}
					>
						Name your Import
					</Typography>

					<Typography
						variant="caption"
						sx={{
							fontFamily: "Inter, sans-serif",
							fontSize: 12,
							fontWeight: 500,
							lineHeight: "15px",
							letterSpacing: 0,
							color: "#757575",
							marginBottom: "16px",
						}}
					>
						Name this task so you can find it later and pick up where you left off.
					</Typography>

					{/* Input */}
					<input
						type="text"
						placeholder="Enter import name"
						autoComplete="off"
						name="import-name-text"
						value={importName}
						onChange={(e) => {
							const value = e.target.value;
							setImportName(e.target.value);

							if (!value.trim()) setImportNameError("Import name cannot be empty");
							if (value.length > 50) setImportNameError("Import name cannot exceed 50 characters");
							if (value.trim() && value.length <= 50) setImportNameError("");
						}}
						style={{
							width: "100%",
							height: 44,
							borderRadius: 8,
							border: "1px solid #D1D5DB",
							padding: "0 12px",
							fontSize: 14,
							outline: "none",
							marginTop: 10,
							marginBottom: 4,
							transition: "all 0.2s ease",
							boxSizing: "border-box",
						}}
						onFocus={(e) => {
							e.target.style.borderColor = "#5441D8";
							e.target.style.boxShadow = "0 0 0 3px rgba(84,65,216,0.15)";
						}}
						onBlur={(e) => {
							if (!e.target.value.trim()) setImportNameError("Import name cannot be empty")
							if (e.target.value.length > 50) setImportNameError("Import name cannot exceed 50 characters")

							e.target.style.borderColor = "#D1D5DB";
							e.target.style.boxShadow = "none";
						}}
					/>
					{
						importNameError && (
							<div
								style={{
									color: "#ef4444",
									fontSize: 12,
									padding: "0 4px",
									marginTop: 0
								}}
							>
								{importNameError}
							</div>
						)
					}
				</div>

				{/* Footer Section */}
				<div
					style={{
						width: "100%",
						height: 69,
						padding: "16px 24px",
						display: "flex",
						justifyContent: "flex-end",
						alignItems: "center",
						gap: 12,
						boxSizing: "border-box",
						borderTop: "1px solid #EEEEEE",
						boxShadow: "0 -4px 8px 0 rgba(0, 0, 0, 0.05)",
						background: "#FFFFFF",
					}}
				>
					<button
						onClick={() => {
							setStep("selectType");
							setImportNameError("");
							setImportName("");
						}}
						style={{
							height: 37,
							padding: "10px 12px",
							borderRadius: 6,
							border: "1px solid #D1D5DB",
							background: "#FFFFFF",
							fontSize: 14,
							fontWeight: 500,
							cursor: "pointer",
						}}
					>
						Back
					</button>
					<button
						onClick={() => {
							setStep("upload");
							setImportNameError("");
						}}
						style={{
							height: 37,
							padding: "10px 16px",
							borderRadius: 6,
							border: "none",
							background: (!!importNameError || !importName.trim()) ? "#E0E0E0" : "#5441D8",
							color: (!!importNameError || !importName.trim()) ? "#757575" : "#FFFFFF",
							fontSize: 14,
							fontWeight: 500,
							style: "medium",
							display: "inline-flex",
							alignItems: "center",
							justifyContent: "center",
							gap: 6,
							cursor: (!!importNameError || !importName.trim()) ? "default" : "pointer",
						}}
						disabled={!!importNameError || !importName.trim()}
					>
						Save & Continue
					</button>
				</div>
			</Dialog>

			{(step === "upload" || step === "mapping" || step === "review") && (
				<div
					style={{
						background: "#F9F9F9",
						height: "calc(100vh - 73px)",
						padding: isMobileLayout ? "0 16px 16px" : "0 24px 24px",
						width: "100%",
						boxSizing: "border-box",
						display: "flex",
						flexDirection: "column",
						alignItems: "stretch",
						overflow: "hidden",
					}}
				>

					{step === "upload" && (
						<div style={stepShellStyle}>
							{/* LEFT SIDE */}
							<div style={leftStepCardStyle}>
								{renderStepperSection()}
								<div style={leftCardTopSectionStyle}>
									<h3 style={{ margin: 0, fontSize: 13, fontWeight: 600, lineHeight: "100%", color: "#424242" }}>
										Upload your CSV file
									</h3>

									<p style={{ fontSize: 12, color: "#757575", marginTop: 4, fontWeight: 500 }}>
										Upload a CSV file to import data into the system.
									</p>

									{/* Download Sample Card */}
									<div
										style={{
											marginTop: 16,
											background: "#F8FAFC",
											border: "1px solid #EEEEEE",
											borderRadius: 6,
											padding: 16,
											display: "flex",
											justifyContent: "space-between",
											alignItems: isMobileLayout ? "flex-start" : "center",
											flexDirection: isMobileLayout ? "column" : "row",
											gap: 12,
										}}
									>
										<div>
											<div style={{ fontWeight: 600, fontSize: 12, color: "#424242", style: "semi-bold" }}>
												Download a sample file to use the CSV template
											</div>
											<div style={{ fontSize: 12, color: "#757575", marginTop: 4, fontWeight: 500, style: "medium" }}>
												Use our template to ensure correct formatting.
											</div>
										</div>

										<Button
											onClick={() => downloadHandler && downloadHandler()}
											style={{
												textTransform: "none",
												display: "flex",
												alignItems: "center",
												//gap: 6,
												height: 27,
												minWidth: "unset",
												padding: "6px 8px",
												borderRadius: 5,
												border: "1px solid #DCD6FF",
												background: "#FFFFFF",
												fontFamily: "Inter, sans-serif",
												fontWeight: 500,
												fontSize: 12,
												lineHeight: "12px",
												letterSpacing: 0,
												color: "#5441D8",
												boxShadow: "none",
											}}
										>
											<img
												src={DownloadIcon}
												alt="download"
												style={{
													width: 14,
													height: 14,
													marginRight: 6,
												}}
											/>
											Download Sample
										</Button>
									</div>
								</div>

								<div style={leftCardBodySectionStyle}>
									{/* Dropzone */}
									<div style={{ marginTop: 24 }}>
										<DropZone
											isActivities={isActivities}
											crmType={crmType}
											setSelectFileName={setSelectFileName}
											setSelectedFileData={setSelectedFileData}
											setIsPicked={setIsPicked}
											setCSVHeaders={setCSVHeaders}
											setHeaderMappings={setHeaderMappings}
											setDownloadHandler={setDownloadHandler}
										/>
									</div>
								</div>

								<div style={leftCardFooterStyle}>
									<div style={{ display: "flex", alignItems: "center", gap: 8, color: "#757575", fontSize: 12, fontFamily: "Inter, sans-serif" }}>
										<img src={Info} alt="info" style={{ width: 16, height: 16 }} />
										<span>
											{!isPicked
												? "Select file to continue with mapping"
												: "File selected. Click Next to proceed to mapping."
											}
										</span>
									</div>

									<button
										disabled={!isPicked}
										onClick={() => isPicked && setStep("mapping")}
										style={{
											padding: "10px 16px",
											borderRadius: 6,
											border: "none",
											background: isPicked ? "#5441D8" : "#E5E7EB",
											color: isPicked ? "#FFFFFF" : "#757575",
											fontSize: 14,
											fontWeight: 600,
											cursor: isPicked ? "pointer" : "default",
											display: "flex",
											alignItems: "center",
											gap: 6,
											fontFamily: "Inter, sans-serif"
										}}
									>
										Next
										<img src={Next} alt="arrow-right" style={{ width: 16, height: 16, filter: isPicked ? "brightness(0) invert(1)" : "none" }} />
									</button>
								</div>
							</div>

							{/* RIGHT GUIDELINES */}
							{renderGuidelinesCard()}
						</div>
					)}




					{step === "mapping" && (
						<div style={stepShellStyle}>

							{/* LEFT SIDE - MAPPING */}
							<div
								style={leftStepCardStyle}
							>
								{renderStepperSection()}
								<div style={leftCardTopSectionStyle}>
									<div
										style={{
											background: "#F8FAFC",
											border: "1px solid #EEEEEE",
											borderRadius: 10,
											padding: isMobileLayout ? "16px" : "16px 20px",
											marginBottom: 24,
											display: "flex",
											alignItems: "center",
											flexWrap: "wrap",
											columnGap: 16,
											rowGap: 8,
										}}
									>
										<span
											style={{
												fontFamily: "Inter, sans-serif",
												fontWeight: 400,
												fontSize: 12,
												color: "#4A5565",
											}}
										>
											File:
										</span>
										<span
											style={{
												fontFamily: "Inter, sans-serif",
												fontWeight: 500,
												fontSize: 12,
												style: "medium",
												color: "#101828"
											}}
										>
											{selectFileName}
										</span>
										{selectedFileData?.parsedData?.length ? (
											<span style={{ fontSize: 12, color: "#616161", fontFamily: "Inter, sans-serif", fontWeight: 500, style: "medium" }}>
												• {selectedFileData.parsedData.length} rows
											</span>
										) : null}
										<span style={{ fontSize: 12, color: "#616161", fontFamily: "Inter, sans-serif", fontWeight: 500, style: "medium" }}>
											• {csvheaders.length} columns/fields
										</span>
									</div>
									<div style={{ marginBottom: 24 }}>
										<h3
											style={{
												marginTop: 0,
												marginBottom: 4, // small gap like Figma
												fontFamily: "Inter, sans-serif",
												fontSize: "13px",
												fontWeight: 600,
												lineHeight: "13px",
												letterSpacing: 0,
												color: "#424242",
											}}
										>
											Field/Column Mapping
										</h3>

										{/* <p
											style={{
												margin: 0,
												fontFamily: "Inter, sans-serif",
												fontSize: "12px",
												fontWeight: 500,
												lineHeight: "12px",
												letterSpacing: 0,
												color: "#616161",
											}}
										>
											Lorem ipsum dolor sit amet consectetur. Aliquam sit enim sed egestas a tincidunt in.
										</p> */}
									</div>
								</div>

								<div className="hide-scrollbar" style={{ ...leftCardScrollableBodyStyle, overflowY: "auto", paddingTop: 0, height: 300 }}>

									{allMappings && allMappings.length > 0 && (
										<CsvMapper
											fileColumns={csvheaders}
											mapping={headerMappings}
											setMapping={setHeaderMappings}
											systemFields={allMappings}
											sampleRow={selectedFileData?.sampleRow || {}}
											deleteIcon={DeleteButton}
											mandatoryFields={mandatoryMappings}
										/>
									)}
								</div>

								<div style={leftCardFooterStyle}>
									<div style={{ display: "flex", alignItems: "center", gap: 8, color: "#757575", fontSize: 12, fontFamily: "Inter, sans-serif" }}>
										<img src={Info} alt="info" style={{ width: 16, height: 16 }} />
										<Typography style={{ fontSize: 13, color: "#374151" }}>
											Unmapped columns will be skipped. You can always re-import to add more fields later
										</Typography>
									</div>
									<button
										disabled={columnsleft > 0}
										onClick={uploadButtonClicked}
										style={{
											padding: "10px 16px",
											borderRadius: 6,
											border: "none",
											background: columnsleft === 0 ? "#5441D8" : "#E5E7EB",
											color: columnsleft === 0 ? "#FFFFFF" : "#757575",
											fontSize: 14,
											fontWeight: 600,
											cursor: columnsleft === 0 ? "pointer" : "default",
											display: "flex",
											alignItems: "center",
											gap: 6,
											fontFamily: "Inter, sans-serif",
											whiteSpace: "nowrap"
										}}
									>
										<img src={Next} alt="arrow-right" style={{ width: 16, height: 16, filter: columnsleft === 0 ? "brightness(0) invert(1)" : "none" }} />
										Import Data
									</button>
								</div>
							</div>

							{/* RIGHT SIDE - GUIDELINES */}
							{renderGuidelinesCard()}

						</div>
					)}

					{step === "review" && reviewStatus === "loading" && (
						<div style={stepShellStyle}>
							<div style={leftStepCardStyle}>
								{renderStepperSection()}
								<div style={{ ...leftCardBodySectionStyle, justifyContent: "center", alignItems: "center", padding: "24px", gap: "24px" }}>
									<div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 10, maxWidth: 501, margin: "0 auto", boxSizing: "border-box", width: "100%", flex: 1 }}>
										{/* Animated Illustration Replacement */}
										<div style={{ backgroundColor: "white", display: "flex", flexDirection: "column", height: "70%", alignItems: "flex-start", justifyContent: "flex-start", overflow: "hidden", position: "relative", borderRadius: 8, width: "100%", maxWidth: 436 }}>
											<div style={{ flexGrow: 1, minHeight: 1, minWidth: 1, overflow: "hidden", position: "relative", width: "100%" }}>
												{/* Shimmer Boxes Background */}
												{[
													{ top: "50% + 0.5px", left: "50% - 112.5px", delay: "0s" },
													{ top: "50% + 0.5px", left: "50% - 224.5px", delay: "0.1s" },
													{ top: "50% - 112px", left: "50% + 56.5px", delay: "0.2s" },
													{ top: "50% + 113px", left: "50% + 56.5px", delay: "0.3s" },
													{ top: "50% - 112px", left: "50% - 55.5px", delay: "0.4s" },
													{ top: "50% + 113px", left: "50% - 55.5px", delay: "0.5s" },
													{ top: "50% - 112px", left: "50% - 167.5px", delay: "0.6s" },
													{ top: "50% + 113px", left: "50% - 167.5px", delay: "0.7s" },
													{ top: "50% + 0.5px", left: "50% + 112.5px", delay: "0.8s" },
													{ top: "50% + 0.5px", left: "50% + 224.5px", delay: "0.9s" },
													{ top: "50% - 112px", left: "50% + 169.5px", delay: "1s" },
													{ top: "50% + 113px", left: "50% + 169.5px", delay: "1.1s" },
												].map((pos, idx) => (
													<div key={idx} style={{ position: "absolute", backgroundColor: "rgb(245, 245, 245)", height: idx < 2 || (idx >= 8 && idx < 10) ? 101 : 102, borderRadius: 12, transform: "translate(-50%, -50%)", width: 102, overflow: "hidden", top: `calc(${pos.top})`, left: `calc(${pos.left})`, border: "1px solid rgb(238, 238, 238)" }}>
														<div style={{ position: "absolute", inset: 0, background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)", transform: "skewX(-12deg)", animation: `shimmer 1.5s linear ${pos.delay} infinite` }}></div>
													</div>
												))}

												{/* Central Animated Content */}
												<div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)", width: 142, height: 142 }}>
													{/* Pulse 1 */}
													<div style={{ position: "absolute", backdropFilter: "blur(0.5px)", backgroundColor: "rgba(220, 214, 255, 0.4)", left: "50%", top: "50%", overflow: "hidden", borderRadius: 16, width: 142, height: 142, transform: "translate(-50%, -50%)", animation: "pulse1 2s ease-in-out 0s infinite" }}>
														<div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)", display: "flex", flexDirection: "column", alignItems: "center", gap: 6, width: 46 }}>
															<div style={{ width: 20, height: 20 }}>
																<svg width="20" height="20" fill="none" viewBox="0 0 20 20"><path d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></path></svg>
															</div>
															<div style={{ fontFamily: "Inter, sans-serif", fontWeight: 600, fontSize: 10, textAlign: "center", color: "white", lineHeight: 1 }}>Search Engines</div>
														</div>
													</div>

													{/* Pulse 2 */}
													<div style={{ position: "absolute", backdropFilter: "blur(0.5px)", backgroundColor: "rgba(220, 214, 255, 0.7)", left: "50%", top: "50%", overflow: "hidden", borderRadius: 15, width: 126, height: 126, transform: "translate(-50%, -50%)", animation: "pulse2 2s ease-in-out 0.3s infinite" }}>
														<div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)", display: "flex", flexDirection: "column", alignItems: "center", gap: 6, width: 46 }}>
															<div style={{ width: 20, height: 20 }}>
																<svg width="20" height="20" fill="none" viewBox="0 0 20 20"><path d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></path></svg>
															</div>
															<div style={{ fontFamily: "Inter, sans-serif", fontWeight: 600, fontSize: 10, textAlign: "center", color: "white", lineHeight: 1 }}>Search Engines</div>
														</div>
													</div>

													{/* Main Animated Box (Pulse 3) */}
													<div style={{ position: "absolute", backgroundColor: "rgb(84, 65, 216)", left: "50%", top: "50%", overflow: "hidden", borderRadius: 12, width: 110, height: 110, transform: "translate(-50%, -50%)", animation: "pulse3 2.5s ease-in-out 0.5s infinite", boxShadow: "rgba(84, 65, 216, 0.3) 0px 0px 12px 2px" }}>
														<div style={{ position: "absolute", left: "50%", top: "50%", width: 64, height: 64, transform: "translate(-50%, -50%)", animation: "sparkleEase 3s ease-in-out infinite" }}>
															<svg xmlns="http://www.w3.org/2000/svg" width="56" height="62" viewBox="0 0 56 62" fill="none">
																<path d="M9.10742 48.3984C9.57796 49.5005 10.2601 50.5139 11.1299 51.376C11.9947 52.233 13.0101 52.9057 14.1133 53.3711C13.0102 53.8365 11.9946 54.5083 11.1299 55.3652C10.2603 56.227 9.57799 57.2402 9.10742 58.3418C8.63685 57.2403 7.95446 56.2269 7.08496 55.3652C6.59033 54.8752 5.91536 54.4722 5.23047 54.1445C4.5931 53.8396 3.9061 53.5814 3.2666 53.3701C3.90595 53.1589 4.59327 52.9025 5.23047 52.5977C5.91557 52.2698 6.59027 51.8662 7.08496 51.376C7.95485 50.5139 8.63683 49.5005 9.10742 48.3984ZM28.1504 9.50293C29.3006 14.2341 31.7459 18.6039 35.2744 22.1006C38.7942 25.5887 43.1894 28.0069 47.9473 29.1494C43.1894 30.2919 38.7943 32.7112 35.2744 36.1992C31.7461 39.6958 29.3007 44.066 28.1504 48.7969C27 44.0661 24.5565 39.6957 21.0283 36.1992C17.5081 32.7107 13.1119 30.2918 8.35352 29.1494C13.1118 28.007 17.5082 25.589 21.0283 22.1006C24.5565 18.604 27.0001 14.2339 28.1504 9.50293ZM47.292 3.65723C47.7626 4.75923 48.4456 5.77277 49.3154 6.63477C50.18 7.49149 51.195 8.16355 52.2979 8.62891C51.1948 9.09433 50.1801 9.76711 49.3154 10.624C48.4457 11.486 47.7626 12.4987 47.292 13.6006C46.8215 12.499 46.14 11.4858 45.2705 10.624C44.4055 9.76679 43.3896 9.09435 42.2861 8.62891C43.3896 8.16349 44.4055 7.49192 45.2705 6.63477C46.1402 5.77291 46.8214 4.75902 47.292 3.65723Z" fill="white" stroke="white" strokeWidth="1.5" strokeLinecap="round"></path>
															</svg>
														</div>
														<div style={{ position: "absolute", inset: 0, pointerEvents: "none", boxShadow: "rgba(255, 255, 255, 0.25) 0px 0px 12px 2px inset", borderRadius: 12 }}></div>
													</div>
												</div>

												{/* Radial Gradient Overlay */}
												<div style={{ position: "absolute", height: 395, left: 0, right: 0, top: 0, background: "radial-gradient(rgba(255, 255, 255, 0) 82.692%, rgb(255, 255, 255) 100%)" }}></div>
											</div>
										</div>
										<div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8, width: "100%" }}>
											<div className="carousel-container" style={{ width: "100%", maxWidth: 501, overflow: "hidden" }}>
												<div className="carousel-track" style={{
													transform: `translateX(-${carouselIndex * 100}%)`,
													transition: isTransitioning ? "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)" : "none"
												}}>
													{[...carouselItems, carouselItems[0]].map((item, idx) => (
														<div key={idx} className="carousel-item">
															<div className="carousel-item-title">{item.title}</div>
															{item.description && <p className="carousel-item-description">{item.description}</p>}
														</div>
													))}
												</div>
											</div>
										</div>
									</div>
								</div>
								<div style={{ ...leftCardFooterStyle, padding: "16px 24px", height: 69, boxShadow: "0 -4px 8px 0 rgba(0, 0, 0, 0.05)", borderTop: "1px solid #EEEEEE" }}>
									<div style={{ display: "flex", alignItems: "center", gap: 8, color: "#424242", fontSize: 12, fontWeight: 400, lineHeight: "100%", letterSpacing: "0%", fontFamily: "Inter, sans-serif" }}>
										{/* <img src={AlertCircle} alt="info" style={{ width: 16, height: 16 }} />
										<span>Lorem ipsum dolor sit amet consectetur. Aliquam sit enim sed egestas a tincidunt in.</span> */}
									</div>
									<button
										onClick={() => { abortControllerRef.current?.abort(); clearInterval(pollIntervalRef.current); setStep("list"); reSelect(); }}
										style={{
											height: 37,
											minWidth: 75,
											padding: "10px 16px",
											borderRadius: 6,
											border: "none",
											background: "#5441D8",
											color: "#FFFFFF",
											fontSize: 14,
											fontWeight: 500,
											lineHeight: "100%",
											letterSpacing: "0%",
											cursor: "pointer",
											display: "flex",
											alignItems: "center",
											gap: 6,
											fontFamily: "Inter, sans-serif"
										}}
									>
										<div style={{ width: 10.67, height: 10.67, background: "#FFFFFF", borderRadius: 1.5 }} />
										Stop Import
									</button>
								</div>
							</div>
							{renderGuidelinesCard()}
						</div>
					)}
					{step === "review" && reviewStatus === "completed" && (
						<>
							<div style={stepShellStyle}>
								<div style={leftStepCardStyle}>
									{renderStepperSection()}
									<div style={{ ...leftCardBodySectionStyle, paddingTop: 24 }}>
										<div style={{
											display: "flex",
											flexDirection: "column",
											gap: 12,
											padding: "12px 16px",
											backgroundColor: "#F8FAFC",
											borderRadius: 10,
											border: "none",
											marginBottom: 24,
											width: "100%",
											boxSizing: "border-box"
										}}>
											<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
												<div style={{ display: "flex", alignItems: "center", gap: 4 }}>
													<img src={CircleX} alt="error" style={{ width: 18, height: 18 }} />
													<Typography style={{ fontSize: 14, fontWeight: 600, color: "#424242" }}>Error Logs</Typography>
												</div>
												<button
													onClick={async () => {
														const url = `${window._env_.OFFLINE_UPLOAD}/error-report/${tenantId}/${userId}/account/${batchId}`;
														const res = await fetch(url);
														const csv = await res.text();
														const blob = new Blob([csv], { type: "text/csv" });
														const a = document.createElement("a");
														a.href = URL.createObjectURL(blob);
														a.download = "error_report.csv";
														a.click();
													}}
													style={{
														border: "none",
														background: "transparent",
														fontFamily: "Inter, sans-serif",
														fontSize: "12px",
														fontWeight: 500,
														lineHeight: "100%",
														letterSpacing: "0%",
														cursor: "pointer",
														color: "#5441D8",
														display: "flex",
														alignItems: "center",
														gap: 8,
														padding: 0
													}}
												>
													<img src={Download} alt="download" style={{ width: 16, height: 16, filter: "brightness(0) saturate(100%) invert(26%) sepia(85%) saturate(3015%) hue-rotate(244deg) brightness(89%) contrast(92%)" }} />
													Download Error Report
												</button>
											</div>
											<div style={{ display: "grid", gridTemplateColumns: isMobileLayout ? "1fr" : "repeat(3, minmax(0, 1fr))", gap: 16 }}>
												{[
													{ label: "Total Rows", value: importStats?.totalRows ?? "–", color: "#424242" },
													{ label: "Successful Rows", value: importStats?.rowsImported ?? "–", color: "#00A75E" },
													{ label: "Failed Rows", value: importStats?.failedRows ?? "–", color: "#F55843" },
												].map((stat) => (
													<div key={stat.label} style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 8, padding: "16px 20px" }}>
														<Typography style={{ fontSize: 12, color: "#6B7280", fontFamily: "Inter, sans-serif", fontWeight: 500 }}>{stat.label}</Typography>
														<Typography style={{ fontSize: 14, fontWeight: 600, color: stat.color, marginTop: 4 }}>{stat.value}</Typography>
													</div>
												))}
											</div>
										</div>
										<div style={{ marginBottom: 24 }}>
											<div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
												<Typography style={{ fontSize: 12, fontWeight: 600, color: "#424242", fontFamily: "Inter, sans-serif" }}>Preview Imported Data</Typography>
												<img src={InfoCircle} alt="info" style={{ width: 14, height: 14, filter: "brightness(0) saturate(100%) invert(48%) sepia(0%) saturate(6%) hue-rotate(189deg) brightness(93%) contrast(85%)" }} />
											</div>
											<Typography style={{ fontSize: 12, color: "#757575", fontWeight: 500, marginBottom: 16, fontFamily: "Inter, sans-serif" }}>
												Select topics to set weightage or drag and drop topics to change the weightage
											</Typography>

											<div style={{
												background: "#fff",
												border: "1px solid #EEEEEE",
												borderRadius: 8,
												overflow: "hidden",
												display: "flex",
												flexDirection: "column",
												width: "100%",
												height: 280,
											}}>
												<div className="hide-scrollbar" style={{ overflowX: "auto", width: "100%", flex: 1 }}>
													{previewRows.length > 0 ? (
														<table style={{ borderCollapse: "collapse", fontSize: 12, fontFamily: "Inter, sans-serif" }}>
															<thead>
																<tr>
																	{csvheaders.map((col, index) => (
																		<th key={col} style={{
																			textAlign: "left",
																			padding: "12px 16px",
																			background: "#F9FAFB",
																			borderBottom: "1px solid #EEEEEE",
																			borderRight: index === csvheaders.length - 1 ? "none" : "1px solid #EEEEEE",
																			color: "#616161",
																			fontWeight: 600,
																			whiteSpace: "nowrap",
																			minWidth: 150,
																		}}>{col}</th>
																	))}
																</tr>
															</thead>
															<tbody>
																{previewRows.map((row, i) => (
																	<tr key={i} style={{ borderBottom: "1px solid #EEEEEE" }}>
																		{csvheaders.map((col, index) => (
																			<td key={col} style={{
																				padding: "12px 16px",
																				color: "#424242",
																				fontSize: col === "Account Name" ? "14px" : "12px",
																				fontWeight: 500,
																				fontFamily: "Inter, sans-serif",
																				whiteSpace: "nowrap",
																				borderRight: index === csvheaders.length - 1 ? "none" : "1px solid #EEEEEE",
																				style: col === "Account Name" ? "semi-bold" : "medium",
																				minWidth: 150,
																			}}>{row[col] ?? ""}</td>
																		))}
																	</tr>
																))}
															</tbody>
														</table>
													) : (
														<div style={{ padding: 20, textAlign: "center", color: "#6B7280" }}>No preview data available.</div>
													)}
												</div>

												{/* Pagination Footer matches Figma */}
												<div style={{
													display: "flex",
													justifyContent: "space-between",
													alignItems: "center",
													padding: "12px 16px",
													borderTop: "1px solid #EEEEEE",
													fontSize: 12,
													color: "#6B7280",
													fontFamily: "Inter, sans-serif"
												}}>
													<div>
														Total rows: {importStats?.rowsImported ?? 0} | Rows: 1 - {previewRows.length}
													</div>

													<div style={{ display: "flex", alignItems: "center", gap: 24 }}>
														<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
															<span>Rows per page:</span>
															<div style={{ position: "relative", display: "flex", alignItems: "center" }}>
																<select style={{
																	padding: "2px 24px 2px 8px",
																	borderRadius: 6,
																	border: "1px solid #E5E7EB",
																	background: "#fff",
																	appearance: "none",
																	cursor: "pointer",
																	fontSize: 12
																}}>
																	<option>10</option>
																</select>
																<img src={ChevronDownIcon} alt="down" style={{ position: "absolute", right: 8, width: 10, height: 10, pointerEvents: "none" }} />
															</div>
														</div>

														<div style={{ display: "flex", alignItems: "center", gap: 12 }}>
															<img src={PagePrevIcon} alt="prev" style={{ width: 14, height: 14, cursor: "pointer", opacity: 0.5 }} />
															<div style={{
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
																width: 20,
																height: 20,
																borderRadius: 4,
																border: "1px solid #5441D8",
																color: "#5441D8",
																fontWeight: 600,
																background: "rgba(84, 65, 216, 0.05)"
															}}>1</div>
															{Math.ceil((importStats?.totalRows || 0) / 10) > 1 && (
																<>
																	<span>...</span>
																	<span>{Math.ceil((importStats?.totalRows || 0) / 10)}</span>
																</>
															)}
															<img src={PageNextIcon} alt="next" style={{ width: 14, height: 14, cursor: "pointer", opacity: Math.ceil((importStats?.totalRows || 0) / 10) > 1 ? 1 : 0.5 }} />
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div style={leftCardFooterStyle}>
										<div style={{ display: "flex", alignItems: "center", gap: 8, color: "#424242", fontSize: 13, fontFamily: "Inter, sans-serif" }}>
											{/* <img src={Info} alt="info" style={{ width: 16, height: 16 }} />
											<span>Lorem ipsum dolor sit amet consectetur. Aliquam sit enim sed egestas a tincidunt in.</span> */}
										</div>
										<button
											onClick={() => { clearInterval(pollIntervalRef.current); setStep("list"); reSelect(); }}
											style={{
												padding: "10px 16px",
												borderRadius: 6,
												border: "none",
												background: "#5441D8",
												color: "#fff",
												fontSize: 14,
												fontWeight: 600,
												cursor: "pointer",
												display: "flex",
												alignItems: "center",
												gap: 6,
												fontFamily: "Inter, sans-serif"
											}}
										>
											<img src={CheckIcon} alt="check" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
											Save & Exit
										</button>
									</div>
								</div>
								{renderGuidelinesCard()}
							</div>
						</>
					)}

				</div>
			)}
			{(step === "list" || step === "selectType" || step === "nameImport") && (
				<>
					{/* = New Data Upload Page UI = */}
					<div
						className="dataUploadPage"
						style={{ padding: 24, background: "#F8FAFC", minHeight: "100vh", width: "100%", boxSizing: "border-box", display: "flex", flexDirection: "column" }}
					>
						{/* Header */}
						<div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
							<img
								src={ChevronLeftIcon}
								alt="Back"
								style={{ width: 24, height: 24, cursor: "pointer" }}
								onClick={() => window.history.back()}
							/>
							<img
								src={FileUploadIcon}
								alt="Upload"
								style={{ width: 32, height: 32 }}
							/>
							<Typography style={{ fontWeight: 600, fontSize: 18, color: "#3D3D3B", style: "semi-bold" }}>
								Data Upload
							</Typography>
						</div>

						{/*  OUTER CARD  */}
						<div
							style={{
								background: "#FFFFFF",
								borderRadius: 8,
								padding: 24,
								flex: 1,
								display: "flex",
								flexDirection: "column",
							}}
						>
							{/* Card Header */}
							<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
								<div>
									<Typography style={{ fontWeight: 700, fontSize: 16, color: "#111827" }}>
										Import History
									</Typography>
									<Typography style={{ fontSize: 12, color: "#6B7280", marginTop: 4 }}>
										Check your recent imports in this section
									</Typography>
								</div>

								<Button
									variant="contained"
									disableElevation
									style={{
										backgroundColor: "#4F46E5",
										color: "#FFFFFF",
										textTransform: "none",
										borderRadius: 6,
										height: 36,
										fontWeight: 600,
										boxShadow: "none",
									}}
									startIcon={<img src={UploadButton} alt="upload" style={{ width: 16, height: 16 }} />}
									onClick={handleNewClick}
								>
									Import Data
								</Button>
							</div>

							{/* Filters */}
							<div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginBottom: 24 }}>
								<div
									style={{
										display: "flex",
										alignItems: "center",
										border: "1px solid #E5E7EB",
										borderRadius: 8,
										padding: "6px 12px",
										gap: 8,
										background: "#fff",
									}}
								>
									<input
										placeholder="Search for a title"
										style={{ border: "none", outline: "none", fontSize: 12, color: "#374151", width: 160 }}
									/>
									<img src={SearchIcon} alt="search" style={{ width: 18, height: 18 }} />
								</div>

								<div
									style={{
										display: "flex",
										alignItems: "center",
										border: "1px solid #E5E7EB",
										borderRadius: 8,
										padding: "6px 12px",
										gap: 6,
										fontSize: 12,
										color: "#374151",
										cursor: "pointer",
										background: "#fff",
									}}
								>
									<img src={FilterListIcon} alt="filter" style={{ width: 14, height: 14 }} />
									Imported By
									<img src={ChevronDownIcon} alt="chevron" style={{ width: 14, height: 14 }} />
								</div>
							</div>

							{/*  INNER TABLE CARD  */}
							<div
								style={{
									background: "#FFFFFF",
									borderRadius: 8,
									border: "1px solid #E5E7EB",
									overflow: "hidden",
									flex: 1,
									display: "flex",
									flexDirection: "column",
								}}
							>
								{/* Table Header */}
								<div className="tableWrapper">
									<div className="tableFixed left">
										<div className="tableCell">
											Import Title
											<img src={ArrowsSortIcon} alt="sort" className="sortIcon" />
										</div>
									</div>

									<div className="tableScrollable">
										<div className="tableScrollableInner">
											{[
												"Status",
												"Data Type",
												"File Name",
												"Rows Imported",
												"Owner",
												"Imported On"
											].map((h) => (
												<div key={h} className="tableCell scrollCell">
													{h}
													<img src={ArrowsSortIcon} alt="sort" className="sortIcon" />
												</div>
											))}
										</div>
									</div>

								</div>

								{/* Empty State */}
								<div
									style={{
										flex: 1,
										minHeight: 360,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										justifyContent: "center",
										color: "#9CA3AF",
										gap: 8,
									}}
								>
									<img src={DashboardEmptyIcon} alt="empty" style={{ width: 80, height: 80 }} />
									<Typography style={{ fontSize: 14, color: "#6B7280" }}>
										No Imports yet
									</Typography>
									<Typography style={{ fontSize: 12, color: "#9CA3AF" }}>
										Click "Import Data" to get started
									</Typography>
								</div>

								{/* Footer */}
								<div
									style={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										borderTop: "1px solid #E5E7EB",
										padding: "12px 24px",
										fontSize: 12,
										color: "#6B7280",
									}}
								>
									<div>Total rows: 0 | Rows: 0</div>

									<div style={{ display: "flex", alignItems: "center", gap: 16 }}>
										<span style={{ fontSize: 14, color: "#6B7280" }}>
											Rows per page:
										</span>

										<div style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
											<select
												style={{
													border: "1px solid #E5E7EB",
													borderRadius: 6,
													padding: "4px 28px 4px 8px", // space for icon
													fontSize: 14,
													height: 28,
													background: "#FFFFFF",
													cursor: "pointer",
													appearance: "none",
													WebkitAppearance: "none",
													MozAppearance: "none",
												}}
											>
												<option>10</option>
											</select>

											<img
												src={RowsDropdownIcon}
												alt="dropdown"
												style={{
													position: "absolute",
													right: 8,
													width: 14,
													height: 14,
													pointerEvents: "none",
												}}
											/>
										</div>

										<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
											<img
												src={PagePrevIcon}
												alt="previous"
												style={{ width: 14, height: 14, cursor: "pointer" }}
											/>

											<div
												style={{
													width: 18,
													height: 18,
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													border: "1px solid #5441D8",
													borderRadius: 2,
													color: "#5441D8",
													fontWeight: 600,
													fontSize: 12,
													background: "rgba(84, 65, 216, 0.1)",
												}}
											>
												1
											</div>

											<img
												src={PageNextIcon}
												alt="next"
												style={{ width: 14, height: 14, cursor: "pointer" }}
											/>
										</div>
									</div>

								</div>
							</div>
							{/* END INNER TABLE CARD */}

						</div>
						{/* END OUTER CARD */}
					</div>
					{/* END dataUploadPage */}
				</>
			)}


		</React.Fragment>
	);
}

export default ManualObjectStart;